import React from "react";
import { AnnotationMenuIconType, AnnotationMenuPropType } from "../AnnotationMenu";
import { AnnotationNumberIcons } from "../helpers/AnnotationNumberIcons";

const AnnotationMenuNumbers = (props: AnnotationMenuPropType) => {
  const display = () => {
    return AnnotationNumberIcons.map((icon: AnnotationMenuIconType, index: number) => {
      return (
        <div
          id={icon.name}
          className={`annotation-icon`}
          key={index}
          onClick={(e: React.MouseEvent<HTMLDivElement>) => props.addNewAnnotation(e.currentTarget.id, "addNumberType")}
        >
          {icon.icon}
        </div>
      );
    });
  };

  return <React.Fragment>{display()}</React.Fragment>;
};

export default AnnotationMenuNumbers;
